import { Box, Grid, GridToolbar } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { AccountStatusFilter } from './AccountStatusFilter'
import { EmployeeListActions } from './EmployeeListActions'
import { EmployeeSearchFilter } from './EmployeeSearchFilter'
import { PaygroupFilter } from './PaygroupFilter'

export const EmployeeFilter = () => {
  return (
    <GridToolbar>
      <Grid container columnGap={2} wrap="nowrap" width="100%">
        <EmployeeSearchFilter />
        <AccountStatusFilter />
        <PaygroupFilter />
        <Box flexGrow={1} />
        <EmployeeListActions />
      </Grid>
    </GridToolbar>
  )
}
